<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9442_47475)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 0H32V32H0V0Z"
        fill="url(#paint0_linear_9442_47475)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.3346 17.1572L24.4882 16.0756C25.9042 16.9236 25.923 17.2744 25.9226 17.2836C25.9202 17.286 25.6786 17.4876 24.3346 17.1572ZM23.5574 16.9412C21.1094 16.2 17.7002 14.636 16.3202 13.984C16.3202 13.9784 16.3218 13.9732 16.3218 13.9676C16.3215 13.7128 16.2201 13.4684 16.0398 13.2882C15.8595 13.108 15.6151 13.0067 15.3602 13.0064C14.8306 13.0064 14.3994 13.4376 14.3994 13.9676C14.3994 14.4976 14.8306 14.9288 15.3602 14.9288C15.593 14.9288 15.8042 14.842 15.971 14.704C17.5942 15.472 20.977 17.0136 23.443 17.7416L22.4682 24.6241C22.4655 24.6426 22.4642 24.6613 22.4642 24.68C22.4642 25.2864 19.7814 26.3996 15.3978 26.3996C10.9678 26.3996 8.2566 25.2864 8.2566 24.6804C8.2566 24.662 8.2554 24.644 8.2526 24.626L6.2154 9.74325C7.979 10.9572 11.7722 11.5992 15.4002 11.5992C19.0226 11.5992 22.8094 10.9592 24.5762 9.74925L23.5574 16.9412ZM6.0002 8.19125C6.029 7.66485 9.0538 5.60005 15.4002 5.60005C21.7458 5.60005 24.771 7.66405 24.8002 8.19125V8.37085C24.4522 9.55085 20.5322 10.8 15.4002 10.8C10.2594 10.8 6.3374 9.54725 6.0002 8.36525V8.19125ZM25.6002 8.20005C25.6002 6.81405 21.6266 4.80005 15.4002 4.80005C9.1738 4.80005 5.2002 6.81405 5.2002 8.20005L5.2378 8.50165L7.457 24.7112C7.5102 26.524 12.3442 27.2 15.3978 27.2C19.1866 27.2 23.2118 26.3288 23.2638 24.712L24.2222 17.9536C24.7554 18.0812 25.1942 18.1464 25.5462 18.1464C26.0198 18.1464 26.3398 18.0304 26.5338 17.7996C26.6116 17.7096 26.6677 17.603 26.698 17.4879C26.7282 17.3728 26.7317 17.2523 26.7082 17.1356C26.6042 16.5824 25.9474 15.9856 24.609 15.222L25.5594 8.51725L25.6002 8.20005Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_9442_47475"
        x1="8.9407e-06"
        y1="2560"
        x2="32"
        y2="4.77582e-06"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1B660F" />
        <stop
          offset="1"
          stop-color="#6CAE3E"
        />
      </linearGradient>
      <clipPath id="clip0_9442_47475">
        <rect
          width="32"
          height="32"
          rx="4"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
